export default __webpack_public_path__ + "static/media/nft_calendar.f7acc9c2.svg";